import { Box, Button, Card, TextField, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useSnackbar } from 'notistack'
import React, { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { UserType } from '../api/appAPI'
import { Center, EnqueueSnackbarType, showMessage } from '../components/common/Helpers'
import { CompanyType, login } from '../redux/appReducer'
import { StateType } from '../redux/store'
import GCLogoSrc from "../assets/GCLogo.png"
import GSLogoSrc from "../assets/GSLogo.png"

const defaultLogoSrc = window.location.hostname.includes('thegarageshop') ? GSLogoSrc : GCLogoSrc

interface IProps {
    user: undefined | UserType
    company: undefined | CompanyType

    login(email: string, password: string, enqueueSnackbar: EnqueueSnackbarType): void
}

const useStyles = makeStyles(theme => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    input: {
        marginBottom: '1rem',
        fontSize: '0.8rem'
    },
    logo: {
        width: '50%',
        marginBottom: '1rem',
        marginTop: "4rem"
    },
    card: {
        minWidth: 320,
        padding: '2rem 3rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // [theme.breakpoints.down('xs')]: {
        //     display: "none"
        // }
    }
}))

const Login: FC<IProps> = props => {
    const styles = useStyles()
    const navigate = useNavigate()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        if (props.user)
            navigate('/profile')
    })

    const handleSubmit = () => {
        if (!email) {
            showMessage(enqueueSnackbar, 'Email is required')
            return
        }
        if (!password) {
            showMessage(enqueueSnackbar, 'Password is required')
            return
        }

        props.login(email, password, enqueueSnackbar)
    }

    return (
        <Center>
            <img className={styles.logo}
                src={props.company ? props.company.logoURL : defaultLogoSrc} alt='Logo' />
            <Card className={styles.card}>
                <Typography style={{ fontWeight: 'bolder' }}>Log In</Typography>
                <Box className={styles.form}>
                    <TextField
                        label="Email"
                        variant="outlined"
                        value={email}
                        onChange={e => { setEmail(e.target.value) }}
                        style={{ width: '100%', marginTop: 15 }}
                        onKeyDown={e => { if (e.key === 'Enter') handleSubmit() }}
                    />
                    <TextField
                        label="Password"
                        variant="outlined"
                        type='password'
                        value={password}
                        onChange={e => { setPassword(e.target.value) }}
                        style={{ width: '100%', marginTop: 15 }}
                        onKeyDown={e => { if (e.key === 'Enter') handleSubmit() }}
                    />
                    <Button style={{ marginTop: 15 }} size="medium" color='primary' variant="contained" onClick={handleSubmit}>Log in</Button>
                </Box>
                <hr style={{ margin: '15px', height: '1px', border: 0, borderTop: '1px solid hsl(0,0%,80%)', width: '100%' }} />
                <Box style={{ display: 'inline', fontSize: "14px" }}>
                    <Link style={{ color: "#0052CC" }} to="/forgot" >Can't log in?</Link>
                    <span>  ᛫  </span>
                    <Link style={{ color: "#0052CC" }} to="/signup" >Sign up for an account</Link>
                </Box>
            </Card>
        </Center>
    )
}

const mapStateToProps = (state: StateType) => ({
    user: state.appReducer.user,
    company: state.appReducer.company
})

export default connect(mapStateToProps, {
    login
})(Login)